import { render, staticRenderFns } from "./propertysCard.vue?vue&type=template&id=21dc6e7d&scoped=true&"
import script from "./propertysCard.vue?vue&type=script&lang=js&"
export * from "./propertysCard.vue?vue&type=script&lang=js&"
import style0 from "./propertysCard.vue?vue&type=style&index=0&id=21dc6e7d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dc6e7d",
  null
  
)

export default component.exports